// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__zZRJm","filesListContainer":"PosDisputesFiles_filesListContainer__1qOvV","filesButton":"PosDisputesFiles_filesButton__3CdnB"};